{
  "pt": {
    "task_assignment": {
      "actions": {
        "confirm": "Marcar como concluída",
        "create": "Tarefa",
        "move_to_draft": "Colocar em rascunho",
        "reopen": "Reabrir",
        "send_and_notify": "Enviar e notificar"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Funcionário",
        "partner": "Parceiro"
      },
      "attributes": {
        "assignee": "Responsável",
        "assignees": "Responsáveis",
        "created_at": "Criado",
        "due_date": "Prazo",
        "project": "Projeto",
        "status": "Estado",
        "task": "Tarefa",
        "unit": "Unidade"
      },
      "confirm": {
        "affected": "Isto afeta {customers} e {team}.",
        "affected_customers": "Isto afeta {customers}.",
        "affected_team": "Isto afeta {team}.",
        "complete_body": "As tarefas deles ficam fechadas e desaparecem da lista, mesmo que não tenham feito nada.",
        "complete_header": "Fechar esta tarefa para todos?",
        "customer_tasks": "{count} tarefa de cliente | {count} tarefas de cliente",
        "draft_body": "A tarefa desaparece até ser enviada outra vez. Os e-mails que já saíram continuam enviados.",
        "draft_header": "Voltar a colocar esta tarefa em rascunho?",
        "send_customers": "Os clientes veem a tarefa de imediato no portal e recebem uma notificação.",
        "send_header": "Enviar para os responsáveis?",
        "send_permanent": "O envio não pode ser anulado. Voltar a colocar a tarefa em rascunho mais tarde não retira a notificação.",
        "send_status": "Ficam em Solicitado.",
        "send_team": "Os membros da equipa são notificados.",
        "team_tasks": "{count} tarefa de equipa | {count} tarefas de equipa"
      },
      "labels": {
        "add_assignee": "Adicionar responsável…",
        "add_customers": "Adicionar clientes",
        "already_assigned": "Esta tarefa já foi adicionada a esta unidade.",
        "already_assigned_project": "Esta tarefa já foi adicionada a este projeto.",
        "completed": "Concluídas",
        "confirm_message": "Tem a certeza de que pretende marcar esta tarefa como concluída?",
        "customers": "Clientes",
        "my_tasks": "As minhas tarefas",
        "no_assignees": "Ainda não há responsáveis.",
        "no_assignments": "Ainda não há tarefas.",
        "no_assignments_task": "Ainda não há atribuições para esta tarefa.",
        "no_assignments_unit": "Ainda não há tarefas para esta unidade.",
        "required": "Este campo é obrigatório",
        "select_task": "Selecione uma tarefa",
        "upload_hint": "Carregue o(s) documento(s) solicitado(s) para concluir esta tarefa.",
        "uploaded_documents": "Documentos carregados"
      },
      "statuses": {
        "completed": "Concluído",
        "draft": "Rascunho",
        "requested": "Solicitado"
      },
      "toasts": {
        "completed": "Tarefa concluída",
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "reopened": "Tarefa reaberta",
        "update": "Tarefa atualizada"
      }
    }
  }
}
